export default __webpack_public_path__ + "static/g2-banner-144357737cdc313de1c3651398726093.png";